import * as React from "react";
function SvgList(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.6 4a1.6 1.6 0 100 3.2h2.133a1.6 1.6 0 100-3.2H5.6zM4 11.4a1 1 0 011-1h14a1 1 0 011 1v1.2a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.2zm0 6.4a1 1 0 011-1h14a1 1 0 011 1V19a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgList);
export default ForwardRef;
